import {
  HttpClient,
  HttpHeaders,
  HttpRequest,
  HttpParams,
} from '@angular/common/http';

import { AuthService } from '../core/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Unlockdconfig } from '../../../sdk/unlockd.config';
import { map } from 'rxjs/operators';
import { MiscHelperService } from './miscHelperService.service';

/**
 * Api services for the `Listing` model.
 */
@Injectable()
export class ListingApi {
  constructor(
    protected http: HttpClient,
    private authService: AuthService,
    private miscHelperService: MiscHelperService
  ) {}

  public getAllListings(offset?, limit?): Observable<any> {
    let url;
    if (offset && limit) {
      url =
        Unlockdconfig.getPath() + `/listings?offset=${offset}&limit=${limit}`;
    } else {
      url = Unlockdconfig.getPath() + '/listings?offset=0&limit=100';
    }
    return this.http
      .get(
        url
        //   , {
        //   headers: new HttpHeaders().set(
        //     'Authorization',
        //     this.authService.getAccessTokenId()
        //   )
        // }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getCityStats(): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/getCityStats`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  public getParishStats(): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/getParishStats`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      })
    );
  }
  public getListingDetailWithClaimerId(
    listing_id: string,
    claimer_id: string
  ): Observable<any> {
    let url;
    // :listing_id/claimers/:claimer_id

    url =
      Unlockdconfig.getPath() +
      `/listings/${listing_id}/claimers/${claimer_id}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingsByZipCode(zipCode): Observable<any> {
    // const params = this.miscHelperService.objectToHttpParams(query_params);
    // Unlockdconfig.getPath() +
    // console.log("in _zip_service..");
    const url = Unlockdconfig.getPath() + `/listings/${zipCode}/postal_code`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log('and this is the response',response);
          return response;
        })
      );
  }

  public getAllAdminListings(query_params): Observable<any> {
    const params = this.miscHelperService.objectToHttpParams(query_params);
    const url = Unlockdconfig.getPath() + `/admin/search`;

    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateListingStatus(listing_id, status): Observable<any> {
    const url = Unlockdconfig.getPath() + `/admin/listings/${listing_id}`;
    return this.http
      .put(
        url,
        { status: status },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateListingType(listing_id, type): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/updatelistingtype/${listing_id}`;
    return this.http
      .put(
        url,
        { listing_type: type },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingById(_id: string, reqquery?): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${_id}`;

    let params;

    if (reqquery) {
      params = new HttpParams().set('options', reqquery);
    }
    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getPublicListingById(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${_id}`;

    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public deleteListingById(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${_id}`;

    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public deleteListingById_(_id: string): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/unsuccessful_listing/${_id}`;

    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public deleteMultipleListingById(ids: any, password): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/delete-listing-admin`;
    let body = {
      listing_ids: ids,
      password: password,
    };
    return this.http.post(url, body, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public getListingCompletenessById(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${_id}/completeness`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public downloadAllImages(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${_id}/downloadall`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
        responseType: 'blob',
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getListingByUserId(user_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/users/${user_id}`;
    const offset = '0';
    const limit = '20';

    const params = new HttpParams().set('offset', offset).set('limit', limit); // now it has aaa
    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingByUserIdEmail(user_id: string,email): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/users/${user_id}/${email}`;
    const offset = '0';
    const limit = '20';

    const params = new HttpParams().set('offset', offset).set('limit', limit); // now it has aaa
    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }


  
  public getListingCount() {
    const url = Unlockdconfig.getPath() + "/listings/user-listing/count";
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public getDocumentsByListingId(listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/listings_documents/${listing_id}`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getDocumentsByUserId(user_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/all_documents/${user_id}`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public uploadDocument(
    listing_id: string,
    doc_obj,
    document
  ): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/documents/${doc_obj._id}/listings/${listing_id}`;

    const formData: FormData = new FormData();
    formData.append('document', document, document.name);

    return this.http
      .put(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateDocument(document_id, data, listing_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/documents/${document_id}/listing/${listing_id}`;
    return this.http
      .put(
        url,
        { body: data },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public uploadSingleDocument(
    listing_id: string,
    data,
    document
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${listing_id}`;
    const formData: FormData = new FormData();
    formData.append('doc', document, document.name);
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        formData.append(key, element);
      }
    }
    return this.http
      .post(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public replaceDocument(
    document_id: string,
    data,
    document
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${document_id}/replaceDocument`;
    const formData: FormData = new FormData();
    formData.append('doc', document, document.name);
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        formData.append(key, element);
      }
    }
    return this.http
      .post(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getSingleDocumentURL(
    document_id: string,
    form_id: string
    // ,version_id: string
  ): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/documents/${document_id}/forms/${form_id}`;

    // const params = new HttpParams().set('version_id', version_id);
    // params: params,
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public uploadAgreementDocument(
    agreement_id: string,
    document
  ): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/listings/agreements/${agreement_id}/upload_agreements_pdf`;
    const formData: FormData = new FormData();
    formData.append('files', document, document.name);
    return this.http
      .post(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public deleteAgreementDocument(
    agreement_id: string,
    key: any
  ): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/listings/${agreement_id}/delete_agreement_pdf`;
    // const formData: FormData = new FormData();
    // formData.append('files', document, document.name);

    let pdfKey = key;
    let obj = {
      pdfKey,
    };
    // for (const key in data) {
    //   if (data.hasOwnProperty(key)) {
    //     const element = data[key];
    //     formData.append(key, element);
    //   }
    // }
    return this.http
      .post(url, obj, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getAgreementSignedUrl(
    key: any
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/download/agreement_pdf`;
    let obj = {
      key,
    };
    return this.http
      .post(url, obj, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingFromCloudSearch(query_params: any): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/search/all/listings`;

    const params = this.miscHelperService.objectToHttpParams(query_params);
    return this.http
      .get(url, {
        params: params,
        // headers: new HttpHeaders().set(
        //   'Authorization',
        //   this.authService.getAccessTokenId()
        // )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingInsideArea(query_params: any): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/insidearea`;

    const params = this.miscHelperService.objectToHttpParams(query_params);
    return this.http
      .get(url, {
        params: params,
        // headers: new HttpHeaders().set(
        //   'Authorization',
        //   this.authService.getAccessTokenId()
        // )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getNearbyListing(query_params: any): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/nearby`;

    const params = this.miscHelperService.objectToHttpParams(query_params);
    return this.http
      .get(url, {
        params: params,
        // headers: new HttpHeaders().set(
        //   'Authorization',
        //   this.authService.getAccessTokenId()
        // )
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getListingFavoritesByUserId(user_id: string): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/listings/favorites/${user_id}?offset=0&limit=100`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getListingFavoriteInfoByUserId(listing_id): Observable<any> {
    const { id } = this.authService.getAccessTokenInfo();
    const url =
      Unlockdconfig.getPath() + `/listings/favorites/${listing_id}/users/${id}`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingPreSignedUrl(listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${listing_id}/images`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getListingLeads(listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${listing_id}/leads`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateSeller(listing_id, body): Observable<any> {
    // const url = Unlockdconfig.getPath() + `/listings/${listing_id}/updateSeller`;
    const url =
      Unlockdconfig.getPath() + `/listings/${listing_id}/updateSeller`;
    return this.http
      .put(url, body, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getListingPreSignedUrlPromise(listing_id: string): Promise<any> {
    const url = Unlockdconfig.getPath() + `/listings/${listing_id}/images`;

    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .toPromise();
  }

  uploadfileAWSS3(fileuploadurl, file): Observable<any> {
    // this will be used to upload all csv files to AWS S3
    // const headers = new HttpHeaders({ 'Content-Type': 'image/jpeg' });
    const req = new HttpRequest('PUT', fileuploadurl, file, {
      // headers: headers,
      reportProgress: true, // This is required for track upload process
    });
    return this.http.request(req);
  }
  uploadfileAWSS3Promise(fileuploadurl, file): Promise<any> {
    // this will be used to upload all csv files to AWS S3
    // const headers = new HttpHeaders({ 'Content-Type': 'image/jpeg' });
    const req = new HttpRequest('PUT', fileuploadurl, file, {
      // headers: headers,
      reportProgress: true, // This is required for track upload process
    });
    return this.http.request(req).toPromise();
  }

  public getFileObject(signedUrl, listing_id): Observable<any> {
    let body = {
      signedUrl: signedUrl,
    };
    const url =
      Unlockdconfig.getPath() + `/listings/getfileObject/${listing_id}`;
    return this.http
      .post(url, body, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public uploadFileToS3(files, listing_id, index): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/listings/upload-single-file/${listing_id}/${index + 1}`;
    const formData: FormData = new FormData();
    // for (const file of files) {
    //   formData.append('files', file.file);
    // }
    formData.append('files', files);
    return this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  /** Triggers Lambda to rebuild compressed/thumb variants after photo edits. */
  public processListingImages(listing_id: string): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/${listing_id}/process-images`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public addListing(
    data: object,
    user_id: string,
    more_services: any,
    listing_type?: string,
    photo_service?: Boolean
  ): Observable<any> {
    // console.log('data inside the front end being sent to the API: ',data,'listing_type is:',listing_type,'more_services',more_services)
    const url = Unlockdconfig.getPath() + `/listings`;
    // data['user_id'] = user_id;

    return this.http
      .post(
        url,
        {
          address: data,
          showing_preferences: {},
          user_id: user_id,
          listing_type: listing_type,
          more_services: more_services,
          photo_service: photo_service,
        },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public addListingImages(
    listing_id: string,
    image: any,
    data?: object
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${listing_id}/images`;
    // data['user_id'] = user_id;
    const formData: FormData = new FormData();
    formData.append('files', image, image.name);
    // formData.append('file_id', data.file_id);
    // formData.append('file_name', data.file_name);
    // formData.append('full_name', data.full_name);

    return this.http
      .post(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateListing(data: object, id: string): Observable<any> {
    // Unlockdconfig.getPath() +
    const url = Unlockdconfig.getPath() + `/listings/${id}`;
    return this.http
      .put(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public getUSerSign(listing_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/${listing_id}/checksignature`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getAgreements(listing_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/${listing_id}/getListingAgreements`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log(response);
          return response;
        })
      );
  }
  public getAgreementsByUserId(user_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/${user_id}/getListingAgreementsByUserId`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log(response);
          return response;
        })
      );
  }
  public getAgreementsForSeller(email): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/getListingAgreementsForSeller/${email}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log(response);
          return response;
        })
      );
  }
  public getAgreementsById(id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/getListingAgreementsById/${id}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log(response);
          return response;
        })
      );
  }
  public getAgreementsDoc(listing_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/getListingAgreementsDoc/${listing_id}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          // console.log(response);
          return response;
        })
      );
  }
  public addAgreements(data: Object): Observable<any> {
    const url = Unlockdconfig.getPath() + `/webhooks/support`;
    return this.http.post(url, data).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  public sendShareEmail(data: object, listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/${listing_id}/share`;
    return this.http
      .post(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public sendSupportEmail(data: Object): Observable<any> {
    const url = Unlockdconfig.getPath() + `/webhooks/support`;
    return this.http.post(url, data).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  public updateListingFavorite(
    listing_id: string,
    user_id: string,
    status: boolean
  ): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/favorites/${listing_id}`;
    return this.http
      .put(
        url,
        { user_id: user_id, status: status },
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getDashboardWidgetsListings(): Observable<any> {
    let url = Unlockdconfig.getPath() + `/admin/dashboard/widgets`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getDashboardPercentageChart(query_params): Observable<any> {
    const params = this.miscHelperService.objectToHttpParams(query_params);
    let url = Unlockdconfig.getPath() + `/admin/dashboard/percentage_chart`;
    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  public getDashboardListingOverviewChart(query_params): Observable<any> {
    const params = this.miscHelperService.objectToHttpParams(query_params);
    let url =
      Unlockdconfig.getPath() + `/admin/dashboard/listing_overview_chart`;
    return this.http
      .get(url, {
        params: params,
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  // getPresigneduUrls(getpresignedurlsserver): Observable<any> {
  //   let getheaders = new HttpHeaders().set('Accept', 'application/json');
  //   return this.http.get(getpresignedurlsserver, { headers: getheaders });
  // }
  public sendLearnMoreEmail(data: any): Observable<any> {
    const url = Unlockdconfig.getPath() + `/webhooks/sendmail`;

    return this.http.post(url, data).pipe((response) => {
      return response;
    });
  }
  public sendAgreement(data): Observable<any> {
    // const url = `http://192.168.10.191:8083/api/listings/add_agreements`;
    const url = Unlockdconfig.getPath() + `/listings/add_agreements`;
    return this.http
      .post(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        // console.log('is service', response);
        return response;
      });
  }

  public updateAgreement(data, agreement_id): Observable<any> {
    // const url = `http://192.168.10.191:8083/api/listings/add_agreements`;
    const url =
      Unlockdconfig.getPath() + `/listings/agreements/${agreement_id}`;
    return this.http
      .put(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        // console.log('is service', response);
        return response;
      });
  }

  public updateTransactionTaskSeller(data, agreement_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/agreements/transaction_task_seller/${agreement_id}`;
    return this.http
      .put(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        // console.log('is service', response);
        return response;
      });
  }

  public addContact(agreement, _id): Observable<any> {
    // console.log(_id);
    const url = Unlockdconfig.getPath() + `/listings/agreements/${_id}`;
    return this.http
      .put(url, agreement, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public deleteAgreement(agreement_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/${agreement_id}/delete_agreements`;
    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }
  updateDealInformation(contact_id, deal_id, data): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/updateDeal/${deal_id}/${contact_id}`;
    return this.http
      .put(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
  updateDealInfoOnListingApproval(listing_id, status): Observable<any> {
    //  console.log('status should never be empty: ',status)
    const url =
      Unlockdconfig.getPath() +
      `/listings/updateDealOnStatusChanged/${listing_id}`;
    return this.http
      .put(url, status, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getContacts(user_id, address): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/allContacts/${user_id}?address=${address}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

   getContactsByUserEmail(email, address): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/allContactsByUserEmail/${email}?address=${address}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getContactsAddress(user_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/contacts/addresses/${user_id}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getLeads(user_id,address,email){
    // const url = Unlockdconfig.getPath() + `/listings/allLeads/${user_id}`;
    const url = Unlockdconfig.getPath() + `/listings/allNewAdminLeads/${user_id}/${email}?address=${address}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  getLeadAddress(user_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/leads/addresses/${user_id}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  addContactToListing(body, _id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/addContacts/${_id}`;
    return this.http
      .put(url, body, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getFormFieldsByDocumentId(documentId: any): Observable<any> {
    const url = Unlockdconfig.getPath() + `/documents/${documentId}/forms`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getTasks(listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/getTasks/${listing_id}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getAllTasksForUsers(user_id: string,address): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/tasks/get-tasks/get-tasks-by-user-id/${user_id}`;
    return this.http
      .post(url,address, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

    getAllTasksForUsersByEmail(email: string,address): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/tasks/get-tasks-by-user-email/${email}`;
    return this.http
      .post(url,address, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getAllListingAddress(user_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/get-address/get-all-addresses/by_user_id/${user_id}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }


  
  getAllListingAddressByEmail(email): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/get-all-property-addresses/${email}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  /********************************* 
      Property Listing Tasks Module

  *********************************/

  addTask(data, listing_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/addTask/${listing_id}`;

    return this.http.post(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  /* editTask(data, task_id, _id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/updateTask/${task_id}/${_id}`;

    return this.http.put(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  } */

  updateTask(data, task_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/updateTask/${task_id}`;

    return this.http.put(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  deleteTask(task_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/deleteTask/${task_id}`;
    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  /************************************* 
      Property Listing Sub Tasks Module

  **************************************/

  addSubTask(data, task_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/Tasks/addSubTask/${task_id}`;

    return this.http.post(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  /* editSubTask(data, task_id, subtaskID): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/Tasks/updateSubTask/${task_id}/${subtaskID}`;

    return this.http.post(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  } */

  updateSubTask(data, task_id, subtaskID): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/Tasks/updateSubTask/${task_id}/${subtaskID}`;

    return this.http.put(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  deleteSubTask(task_id, subtaskID): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/Tasks/deleteSubTask/${task_id}/${subtaskID}`;
    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  // User frontend task update

  updateFrontendTask(
    task_status: boolean,
    task_id: string,
    subtask_status: boolean,
    subtaskID: string,
    user_id: string
  ): Observable<any> {
    const url =
      Unlockdconfig.getPath() +
      `/Tasks/updateFrontendTask/${task_id}/${subtaskID}`;

    let data = {
      task_status: task_status,
      subtask_status: subtask_status,
      user_id: user_id,
    };

    return this.http.put(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  changeFeatureStatus(id, is_featured) {
    const url = Unlockdconfig.getPath() + `/admin/changeIsFeatured`;
    let body = {
      id: id,
      is_featured: is_featured,
    };
    return this.http
      .post(url, body, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  getFeaturedListings() {
    const url = Unlockdconfig.getPath() + `/listings/getFeaturedListings`;
    return this.http.get(url).pipe((response) => {
      return response;
    });
  }

  getNoOfListings() {
    const url = Unlockdconfig.getPath() + `/listings/getnooflistings`;
    return this.http.get(url).pipe((response) => {
      return response;
    });
  }

  public getLead(_id) {
    const url = Unlockdconfig.getPath() + `/AdminLeads/getLeads/${_id}`;
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public getLeadById(_id) {
    const url = Unlockdconfig.getPath() + `/AdminLeads/getLeadById/${_id}`;
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }


  public sendLead(data, _id,file) {
    const formData: FormData = new FormData();
    if(file){
    formData.append('file', file, file?.name);
    }
    formData.append('data', JSON.stringify(data));
    const url = Unlockdconfig.getPath() + `/AdminLeads/addLeads/${_id}`;
    return this.http.post(url, formData, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public editLead(data, lead_id) {
    const url = Unlockdconfig.getPath() + `/AdminLeads/updateLead/${lead_id}`;
    return this.http.put(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public updateImage(file: any,id?:any): Observable<any> {
    if(!id){
        id = this.authService.getAccessTokenInfo()?.id;
    }
    const url = Unlockdconfig.getPath() + `/AdminLeads/${id}/avatar`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.http
      .post(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public saveNotes(data, lead_id) {
    const url = Unlockdconfig.getPath() + `/AdminLeads/add-note/${lead_id}`;
    return this.http.post(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public deleteLead(lead_id) {
    const url = Unlockdconfig.getPath() + `/AdminLeads/deleteLead/${lead_id}`;
    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  sendMessageToAdminNewTask(data, msgTo): Observable<any> {
    let url = Unlockdconfig.getPath() + '/Tasks/sendAdminNewTaskMsg';
    let body = {
      title: data.title,
      description: data.description,
      msgTo: msgTo,
    };
    return this.http.post(url, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  removeFromFeatured(id: any) {
    const url = Unlockdconfig.getPath() + `/listings/removeFromFeatured/remove`;
    let body = {
      id: id,
    };
    return this.http.put(url, body).pipe((response) => {
      return response;
    });
  }

  downloadPreShootCheckList() {
    const url =
      Unlockdconfig.getPath() + `/listings/download/getPreShootChecklistPdf`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  deleteImages(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/deleteFiles/${_id}`;

    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  downloadPropertyDisclosureDoc(state: string) {
    const url =
      Unlockdconfig.getPath() +
      `/listings/download/getPropertyDisclosurePdf/${state}`;
    return this.http
      .get(url, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  viewBrokerageServicesDoc() {
    const url = Unlockdconfig.getPath() + `/listings/view/getBrokerageServicesPdf`;
    return this.http
    .get(
      url
    )
    .pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  postAdminNotificationForOutOfReachLocation(
    message,
    user_id,
    email,
    address,
    seller_name,
    phone_number
  ) {
    const url = Unlockdconfig.getPath() + `/listings/postAdminNotification`;
    let body = {
      message: message,
      user_id: user_id,
      // email: email,
      address: address,
      seller_name: seller_name,
      // phone: phone_number,
    };
    return this.http
      .post(url, body, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }


  public getChangeRequestByListingId(id) {
    const url = Unlockdconfig.getPath() + `/mls-change-request/get-request/${id}`;
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public getAllRequest(start: any, size: any): Observable<any>  {
    const url = Unlockdconfig.getPath() + `/mls-change-request/get-all-request`;
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
       params: {
        start: start,
        size: size
      }
    });
  }

  public createMlsChangeRequest(data) {
    const url = Unlockdconfig.getPath() + `/mls-change-request/create-request`;
    return this.http.post(url, data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  public updateMlsChangeRequest(data, _id){
    const url = Unlockdconfig.getPath() +`/mls-change-request/update-request/${_id}`
    return this.http.put(url,data, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
  });
  }

  public updateRequestStatus(id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/mls-change-request/update-request-status/${id}`;
    return this.http
      .get(
        url,
        {
          headers: new HttpHeaders().set(
            'Authorization',
            this.authService.getAccessTokenId()
          ),
        }
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  sendMessageToAdminMlsChangeRequest(data): Observable<any> {
    let url = Unlockdconfig.getPath() + '/mls-change-request/sendAdminMCRMsg';
    let body = {
      note: data.note,
      name: data.name,
      email: data.email,
      phone: data.phone,
      request: data.change_request,
      address: data.address
    };
    return this.http.post(url, body).pipe(
      map((response) => {
        return response;
      })
    );
  }

  public addTransactionTask(transaction_task,agreement_id): Observable<any> {
    // console.log(transaction_task);
    let data: any = {
      transaction_task: transaction_task,
      agreement_id: agreement_id
    };
    const url = Unlockdconfig.getPath() + `/listings/add_transaction_task`;
    return this.http
      .post(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        // console.log('is service', response);
        return response;
      });
  }

  public updateTransactionTask(data, agreement_id): Observable<any> {
    const url =
      Unlockdconfig.getPath() + `/listings/update_transaction_task/${agreement_id}`;
    return this.http
      .put(url, data, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        // console.log('is service', response);
        return response;
      });
  }

  getTransactionTask(agreement_id): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/getTransactionTask/${agreement_id}`;
    return this.http
      .get(url,{
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe((response) => {
        return response;
      });
  }

  public addSellersInfo(data: object, id: string,file: any, file_rectangle: any): Observable<any> {
    const formData: FormData = new FormData();
    if(file_rectangle && file){
    formData.append('file', file, file?.name);
    formData.append('file_rectangle', file_rectangle, file_rectangle?.name);
    }
    formData.append('data', JSON.stringify(data));
    const url = Unlockdconfig.getPath() + `/listings/add_seller_2/${id}`;
    return this.http
      .put(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public updateSellersInfo(data: object,idInfo,file: any, file_rectangle: any): Observable<any> {
    const formData: FormData = new FormData();
    if(file_rectangle && file){
      formData.append('file', file, file?.name);
      formData.append('file_rectangle', file_rectangle, file_rectangle?.name);
    }
    formData.append('data', JSON.stringify(data));
    const url = Unlockdconfig.getPath() + `/listings/edit_seller/${idInfo.listing_id}/${idInfo.seller_id}/${idInfo.contact_id}`;
    return this.http
      .put(url, formData, {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        ),
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }


  public deleteSeller(_id: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/delete_seller_2/${_id}`;

    return this.http.delete(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    });
  }

  validatePassword(password: string): Observable<string> {
    const url = Unlockdconfig.getPath() + `/listings/admin-password-validator`;
    return this.http
    .post(url, {password}, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
    })
    .pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  getListingsByState(stateName): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/getAddressByStateName/${stateName}`;
    return this.http.get(url,{
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
     }).pipe(
      map((response: any) => {
        // console.log(response)
        return response;
      })
    )
  }

  getAllDocumentsByListingId(sort?: string): Observable<any> {
    const url = Unlockdconfig.getPath() + `/listings/documents/listing-all-documents?sort=${sort}`;
    return this.http.get(url,{
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      ),
     }).pipe(
      map((response: any) => {
        // console.log(response)
        return response;
      })
    )
  }

}
